import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { DriverEvent } from '../../models/driver-event';


@Component({
    templateUrl: './driver-events-confirmation-modal.component.html',
    styleUrls: [
        './../../../../../styles.scss',
        './driver-events-confirmation-modal.component.scss'
    ],
    encapsulation: ViewEncapsulation.ShadowDom
})
export class DriverEventsConfirmationModalComponent implements OnInit {
    @Input() driverEvent!: DriverEvent;
    @Output() driverEventConfirmed = new EventEmitter<DriverEvent>();

    constructor(
        public activeModal: BsModalRef,
    ) { }

    ngOnInit() { }

    close() {
        this.activeModal.hide();
    }

    confirmEvent() {
        this.driverEventConfirmed.emit(this.driverEvent);
        this.close();
    }

    cancelEvent() {
        this.close();
    }
}
